import React from 'react';
import {EventInvoice} from '../UnpaidInvoices';
import InvoiceRow from './InvoiceRow';

type Props = {
  invoices: EventInvoice[]
  stripePublicKey: string
}

export default function InvoiceTable({invoices, stripePublicKey}: Props) {
  return (
    <div className="grid grid-cols-12 gap-x-1 gap-y-4 text-base pt-3 px-5">
      <div className="col-span-8 grid grid-cols-12 text-gray-dark">
        Event
      </div>
      <div className="col-span-4">
        <div className="grid grid-cols-2 text-gray-dark">
          <div>Sent on</div>
          <div className="text-right">Amount</div>
        </div>
      </div>
      {invoices.map((invoice) => <InvoiceRow key={invoice.eventId} invoice={invoice} stripePublicKey={stripePublicKey}/>)}
    </div>
  );
}
